import React from 'react';
import { AgentChatImageAttachment } from './AgentChat.types';
import AgentAttachedTrackCard from './AgentAttachedTrackCard';
import { parseAttachedTrackMessage } from './agentAttachedTrack';
import { attachmentSrc } from './agentImageAttachments';

interface AgentUserMessageBodyProps {
  content: string;
  attachments?: AgentChatImageAttachment[] | null;
}

export const AgentUserMessageBody: React.FC<AgentUserMessageBodyProps> = ({
  content,
  attachments,
}) => {
  const parsed = parseAttachedTrackMessage(content);
  const images = attachments ?? [];
  if (!parsed && images.length === 0) return <>{content}</>;

  return (
    <div className="agent-user-message">
      {images.length > 0 && (
        <div className="agent-user-images">
          {images.map((image, index) => (
            <img
              key={image.id}
              src={attachmentSrc(image)}
              alt={`Screenshot ${index + 1}`}
              className="agent-user-image"
            />
          ))}
        </div>
      )}
      {parsed && <AgentAttachedTrackCard track={parsed.track} />}
      {parsed ? (
        parsed.prompt ? (
          <p className="agent-user-message-prompt">{parsed.prompt}</p>
        ) : null
      ) : (
        <p className="agent-user-message-prompt">{content}</p>
      )}
    </div>
  );
};

const sameAttachments = (
  prev: AgentUserMessageBodyProps,
  next: AgentUserMessageBodyProps,
): boolean =>
  prev.content === next.content &&
  (prev.attachments ?? []).map((image) => image.id).join(',') ===
    (next.attachments ?? []).map((image) => image.id).join(',');

// Keeps screenshot bubbles from re-rendering on every streamed token.
export default React.memo(AgentUserMessageBody, sameAttachments);
